<main class="custom-route-desktop">
  @switch (desktopViewState()) {
    @case (customRouteDesktopViews.map) {
      @if (isWelcomeViewShown()) {
        <app-welcome-planner-view />
      }
      <app-planner />
      <app-map />
      <app-actions-footer-bar />
    }
    @case (customRouteDesktopViews.more) {
      <app-more />
    }
  }
</main>